import { call, put, takeLatest } from 'redux-saga/effects';
import { DELETE_GATEWAY_REQUEST } from './constants';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import { notify } from 'sharedComponents/GeneralNotification';
import { translate } from 'helpers/translateHelper';
import { GATEWAY_MAIN_TYPES, GATEWAY_SUB_TYPES } from '../../../../GatewayManagement/constants';
import { getGatewayDeleteAction } from './actions';
import { getGatewayList, getGatewayListAction } from '../../../../GatewayManagement/actions';
import { getGatewayInfoAction } from '../../actions';
function* deleteGatewaySaga(action) {
    const { gatewayID, organizationID, gatewayFilter } = action;
    yield put(getGatewayDeleteAction(apiCallStatus.LOADING));
    yield put(getGatewayListAction(apiCallStatus.LOADING));
    yield put(getGatewayInfoAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.deleteGateway, gatewayID);
        if (response?.success) {
            yield put(getGatewayDeleteAction(apiCallStatus.SUCCESS));
            notify(translate('ABB.Powertrain.Frontend.GatewayDeleteSuccessMessage'), NOTIFICATION_TYPES.SUCCESS);
        } else if (response?.error) {
            notify(response?.error?.message, NOTIFICATION_TYPES.ERROR, true);
        }
        // Use getGatewayList action creator which handles organizationID/siteId logic
        yield put(getGatewayList(
            organizationID,
            [],
            null,
            gatewayFilter || {
                type: GATEWAY_MAIN_TYPES.MY_GATEWAYS,
                subType: GATEWAY_SUB_TYPES.NONE
            }
        ));
        yield put(getGatewayListAction(apiCallStatus.SUCCESS));
        yield put(getGatewayInfoAction(apiCallStatus.SUCCESS));
    } catch (error) {
        yield put(getGatewayDeleteAction(apiCallStatus.ERROR, [], error));
    }
}

export function* gatewayDetailsWatchers() {
    yield takeLatest(DELETE_GATEWAY_REQUEST, deleteGatewaySaga);
}
